import * as echarts from "echarts";
import "./../assets/styles/index.scss";
import photoSphereViewer from "./photoSphereViewer.vue";
import { markers, photos } from "@/api/data.js";
// import titleBox from "@/components/title/title.vue";
// import borderBox from "@/components/borderBox/borderBox.vue";
// import headers from "@/components/headers/headers.vue";
// import cameraPopup from "@/components/cameraPopup/index.vue";
export default {
  props: [],
  data() {
    return {
      photoList: photos,
      noticeTitle: '',
      // 是否显示欢迎词
      showNotice: '0',
      // 欢迎词是否滚动
      showNoticeScroll: '0',
      // 字号
      fontSize: null,
      // 字间距
      letterSpacing: null
    };
  },
  components: {
    // titleBox,
    // borderBox,
    photoSphereViewer
    // headers,
    // cameraPopup,
  },

  created() {},
  async mounted() {
    await this.getWelcomeList();
    let dom = document.querySelector('.text_content');
    const style = window.getComputedStyle(dom, null);
    let height = parseInt(style.height, 10);
    let lineHeight = parseInt(style.lineHeight, 10);
    let lineNum = height / lineHeight;
    if (lineNum >= 2) {
      this.showNoticeScroll = '1';
    }
    console.log(style.height, style.lineHeight, lineNum, '文字');
  },
  methods: {
    addNewItem(content) {
      const newItem = document.createElement('div');
      newItem.className = 'text_content';
      newItem.textContent = this.noticeTitle;
      content.appendChild(newItem);
    },
    selectMarker(marker) {
      console.log(marker, "marker");
      const myViewer = this.$refs.viewer;
      if (marker.id == "new-marker1") {
        myViewer.updateIndex(1);
      } else if (marker.id == "marker_weather") {
        this.$refs.weatherDialog.open("40261986");
      } else if (marker.id == "new-marker3") {
        this.$refs.plotDialog.open("119");
      } else if (marker.id == "new-marker4") {
        this.$refs.plotDialog.open("120");
      }

      // if (marker.id == "new-marker2") {
      //   myViewer.updateIndex(2);
      // }
      if (marker.id == "new-marker21") {
        myViewer.updateIndex(0);
      }
      if (marker.id == "bowuguanNeijing") {
        myViewer.updateIndex(2);
      }
      if (marker.id == "huahaiNeijing") {
        myViewer.updateIndex(3);
      }
      // if (marker.id == "new-marker3") {
      //   myViewer.updateMarker(marker.id, require("./../assets/tpano.png"));
      // } else {
      //   myViewer.handelChangeViewer();
      // }
    },

    // 获取领导欢迎语
    async getWelcomeList() {
      let {
        rows
      } = await this.$api.getWelcomeList({});
      this.noticeTitle = rows[0].noticeTitle;
      this.showNotice = rows[0].status;
      this.fontSize = rows[0].font;
      this.letterSpacing = rows[0].space;
      console.log(rows, '获取领导欢迎语');
    }
  }
};